import { Component, OnInit, Input } from '@angular/core';
import { SeatmapRowInt} from "@interfaces/*";

/**
 * Componente que representa una fila de asientos en el mapa de un avión.
 */
@Component({
    selector: 'app-am-row-plane',
    templateUrl: './am-row-plane.component.html',
    styleUrls: ['./am-row-plane.component.scss'],
    standalone: false
})
export class AmRowPlaneComponent implements OnInit {
   /**
   * Información de la fila de asientos.
   */

  @Input() seatDiv2:SeatmapRowInt

 /**
   * Lista de bloques de asientos dentro de la fila.
   */

  rowsOfBlock: Array<any> = [];
  /**
   * Índice de la fila en el mapa de asientos.
   */
  @Input() index

  /**
   * Clase asociada a la fila de asientos.
   */
  @Input() classrow;
    /**
   * Nombre del avión al que pertenece la fila de asientos.
   */
  @Input() airplane: string;
  @Input() id: string;
  constructor() { }

  ngOnInit(): void {
  }

  get columns(): string[] {
    const seen = new Set<string>();
    return (this.seatDiv2?.seats ?? [])
      .map(s => s.column)
      .filter(c => !seen.has(c) && (seen.add(c), true));
  }

}
